import React from "react";
import { Controller } from "react-hook-form";
import { formBuilderParams } from "../FormBuilder";
import { formRulesBuilder } from "../lib/FormBuilderRules";
import Datepicker from "components/Input/Datepicker/Datepicker";
import { useDefaultValueTriggerUpdate, useRemoveMandatoryError } from "../Utils/FormBuilderUtils";
import dayjs from "dayjs";

/**
 * @typedef {import("../lib/FormBuilderFieldBuilder").baseFormComponentProps} baseFormComponentProps
 * @typedef {import("../lib/FormBuilderFieldBuilder").baseConfig} baseConfig
 * @typedef {import("../lib/FormBuilderFieldBuilder").datePickerConfig} datePickerConfig
 * @param {baseFormComponentProps & baseConfig & datePickerConfig} props
 */
const FormBuilderDatePicker = ({
  formProps,
  fieldName,
  defaultValue = null,
  defaultValueTriggerUpdate = false,
  mandatory = false,
  rules,
  customRule,
  label,
  subLabel,
  hideLabel,
  noErrorMessage = false,
  rangeType,
  limitValue,
  minDate,
  maxDate,
  disabled = false,
  readOnly = false,
}) => {
  useRemoveMandatoryError({ fieldName, mandatory, formProps });
  defaultValueTriggerUpdate && useDefaultValueTriggerUpdate({ fieldName, defaultValue, formProps });

  return (
    <Controller
      key={fieldName}
      name={fieldName}
      control={formProps.control}
      defaultValue={defaultValue}
      rules={formRulesBuilder({ mandatory, rules, customRule })}
      render={({ field: { value, onChange, ref }, fieldState: { error } }) =>
        <Datepicker
          inputRef={ref}
          label={label}
          subLabel={subLabel}
          hideLabel={hideLabel === "removePadding"}
          emptyLabel={hideLabel === "keepPadding"}
          noErrorMessage={noErrorMessage}
          type={rangeType}
          limitValue={limitValue}
          minDate={minDate}
          maxDate={maxDate}
          value={value}
          onchangeFn={(value) => {
            const newValue = dayjs.isDayjs(value) ? value.toISOString() : value;
            onChange(newValue);
          }}
          errorMessage={error?.message || ""}
          sxParams={{
            datepickerError: !!error,
          }}
          divStyle={formBuilderParams.formItemStyle}
          disabled={disabled}
          readOnly={readOnly}
          mandatory={mandatory}
        />
      }
    />
  );
}

export default FormBuilderDatePicker;